import { createContext, useContext, useState, ReactNode, useCallback, useMemo } from "react";

type SpotlightSearchContextType = {
    isOpen: boolean;
    openSpotlight: () => void;
    closeSpotlight: () => void;
};

const SpotlightSearchContext = createContext<SpotlightSearchContextType | undefined>(undefined);

export function SpotlightSearchProvider({ children }: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);

    const openSpotlight = useCallback(() => {
        setIsOpen(true);
    }, []);

    const closeSpotlight = useCallback(() => {
        setIsOpen(false);
    }, []);

    const value = useMemo(() => ({ isOpen, openSpotlight, closeSpotlight }), [isOpen, openSpotlight, closeSpotlight]);

    return <SpotlightSearchContext.Provider value={value}>{children}</SpotlightSearchContext.Provider>;
}

export function useSpotlightSearch() {
    const context = useContext(SpotlightSearchContext);
    if (!context) {
        throw new Error("useSpotlightSearch must be used within a SpotlightSearchProvider");
    }
    return context;
}
